import { sum } from "simple-utils";
import { props, propsLabel, Summary } from "../ads-procedure-report-page/procedure-models";
import { Column } from "../table/Table";
import { bigNumber, formatMoney } from "../utils/money-utils";
import { ChannelReport, ChannelReportEntry, channels, ChannelType } from "./channel-models";

type Getter = {
    (g:ChannelReportEntry):number
    key?:string
}

function getter(channel:ChannelType, prop:keyof Summary){
    let result:Getter = (g:ChannelReportEntry):number => g.info[channel]?.[prop] ?? 0
    result.key = `${channel}.${prop}`;
    return result; 
}

export type NumberColumn = Column<ChannelReportEntry> & ({getter: (r: ChannelReportEntry) => number});

function getColumns(type: ChannelType):NumberColumn[]{
    return props.map(p => {
        let g = getter(type, p);
        return {
            id: g.key,
            label: propsLabel[p],
            colGroup: p.match(/leads/) ? 'col-divider text-end' : 'text-end',
            render: p == 'spend' ? r => formatMoney(g(r)) : (r) => bigNumber(g(r)),
            getter: g
        }
    });
}

function getBaseColumns(type: ChannelType):NumberColumn[]{
    let getLeads = getter(type, "leads");
    let getSpend = getter(type, "spend");
    let getCPL:Getter = (r) => getLeads(r) == 0 ? 0 : getSpend(r) / (getLeads(r)) 
    getCPL.key = type + ".cpl"
    
    return [{
            id: getLeads.key,
            label: "Leads",
            render: (r) => bigNumber(getLeads(r)),
            colGroup: 'col-divider text-end',
            getter: getLeads
        },

        {
            id: getCPL.key,
            label: "CPL",
            render: (r) => formatMoney(getCPL(r)),
            colGroup: 'text-end',
            getter: getCPL
        }
    ]
}

function getTotalColumns():NumberColumn[]{
    let getLeads:Getter = (r) => sum(Object.values(r.info), i => i.leads ?? 0) 
    getLeads.key = "total.leads"

    let getSpend:Getter = (r) => sum(Object.values(r.info), i => i.spend ?? 0) 
    getSpend.key = "total.spend"
    
    return [{
            id: getLeads.key,
            label: "Leads",
            render: (r) => bigNumber(getLeads(r)),
            colGroup: 'col-divider text-end',
            getter: getLeads
        },

        {
            id: getSpend.key,
            label: "Investimento",
            render: (r) => formatMoney(getSpend(r)),
            colGroup: 'text-end',
            getter: getSpend
        }
    ]
}

export const channelNumberColumns = channels/*.filter(c => c != 'nd')*/.flatMap(k => getBaseColumns(k)).concat(getTotalColumns()) ;